import React from "react"
import styled from "styled-components"

import { Section, Container } from "../global"

const STEPS = [
  {
    emoji: "📝",
    title: "Set your intentions",
    text: "Decide what your perfect day looks like. A walk, a meditation, a page written — whatever showing up means to you.",
  },
  {
    emoji: "☀️",
    title: "Add your day",
    text: "One tap puts your sun up. Spin the wheel to earn BTC points — and if you're lucky, catch the rare golden sun 🌟.",
  },
  {
    emoji: "🎉",
    title: "Check in & get cheered",
    text: "Log a mood, a note, or a photo. The community sends 🔥 💪 ☀️ 🎉 to celebrate you showing up.",
  },
]

const HowItWorks = () => (
  <Section id="how-it-works">
    <StyledContainer>
      <Subtitle>How Day works</Subtitle>
      <SectionTitle>Three small steps. Every day.</SectionTitle>
      <StepsGrid>
        {STEPS.map((step, i) => (
          <StepCard key={step.title}>
            <StepNumber>{i + 1}</StepNumber>
            <StepEmoji>{step.emoji}</StepEmoji>
            <StepTitle>{step.title}</StepTitle>
            <StepText>{step.text}</StepText>
          </StepCard>
        ))}
      </StepsGrid>
    </StyledContainer>
  </Section>
)

export default HowItWorks

const StyledContainer = styled(Container)``

const SectionTitle = styled.h3`
  color: ${(props) => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 48px;
  text-align: center;
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: ${(props) => props.theme.color.accent};
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 12px;
  text-align: center;
`

const StepsGrid = styled.div`
  max-width: 1000px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 0 auto;
  grid-column-gap: 32px;
  grid-row-gap: 32px;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    padding: 0 32px;
  }
`

const StepCard = styled.div`
  position: relative;
  background: #fffaf1;
  border: 1px solid #ffe9c7;
  border-radius: 20px;
  padding: 36px 28px 28px;
  text-align: center;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 32px rgba(219, 152, 64, 0.18);
  }
`

const StepNumber = styled.div`
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(90deg, #ffb347 0%, #db9840 100%);
  color: white;
  font-family: ${(props) => props.theme.font.bold};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
`

const StepEmoji = styled.div`
  font-size: 40px;
  margin-bottom: 12px;
`

const StepTitle = styled.h4`
  color: ${(props) => props.theme.color.primary};
  margin: 0 0 10px;
`

const StepText = styled.p`
  margin: 0;
  color: ${(props) => props.theme.color.black.light};
  line-height: 24px;
`
